import { Component } from "@angular/core";

@Component({
  selector: 'pg-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss']
})
export class FaqPage {

  constructor(){
  }
}